
import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const OrderLinesBlock = ({ items = [],t }) => {
    return (
        <Box>
            <Typography
                sx={{
                    fontFamily: "'Zen Maru Gothic', sans-serif",
                    fontWeight: 900,
                    fontSize: 24,
                    textTransform: "uppercase",
                    mb: 2,
                    color: "#111111",
                }}
            >
                {t("My order")}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                {items.map((item) => (
                    <OrderLineRow key={item.id} item={item} />
                ))}
            </Box>
        </Box>
    );
};

const OrderLineRow = ({ item }) => {
    const { image, quantityLabel, sku, name, price } = item;

    return (
        <Paper
            elevation={0}
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
                px: 1.5,
                py: 1,
                borderRadius: "10px",
                bgcolor: "#E9E9E9",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    minWidth: 0,
                }}
            >
                <Box
                    sx={{
                        width: 82,
                        height: 72,
                        borderRadius: 1,
                        overflow: "hidden",
                        bgcolor: "#E9E9E9",
                        flexShrink: 0,
                    }}
                >
                    <Box
                        component="img"
                        src={image}
                        alt={name}
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.3,
                        minWidth: 0,
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 700,
                            fontSize: 16,
                            color: "#E5007E",
                        }}
                    >
                        {quantityLabel}
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 700,
                            fontSize: 14,
                            color: "#111111",
                        }}
                    >
                        {sku}
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 400,
                            fontSize: 14,
                            color: "#111111",
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                        }}
                    >
                        {name}
                    </Typography>
                </Box>
            </Box>

            <Typography
                sx={{
                    fontFamily: "'Roboto Condensed', sans-serif",
                    fontWeight: 700,
                    fontSize: 16,
                    color: "#111111",
                    textAlign: "right",
                    minWidth: 75,
                }}
            >
                {price}
            </Typography>
        </Paper>
    );
};

export default OrderLinesBlock;
